import { useQuery } from '@tanstack/react-query'

import { useAuthInfo } from '@sweetauth/core'

import { API_URL } from '@/constants/env'

import type { TiptapTokenResponse } from '@/types/Tiptap'

export const fetchTiptapToken = async (
  orgId: string,
  documentId: string,
  accessToken: string | undefined | null,
): Promise<string> => {
  if (accessToken === null || accessToken === undefined) {
    throw new Error('No access token provided.')
  }
  const res: Response = await fetch(
    `${API_URL}/api/v1/tiptap/${orgId}/token/${encodeURIComponent(documentId)}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    },
  )
  if (!res.ok) {
    throw new Error(res.statusText)
  }
  const res_json: TiptapTokenResponse = await res.json()
  return res_json.token
}

export const useTiptapToken = (orgId: string, documentId: string) => {
  const user = useAuthInfo()
  return useQuery({
    queryFn: () => fetchTiptapToken(orgId, documentId, user?.accessToken),
    queryKey: [user?.user?.userId, orgId, documentId, 'tiptapToken'],
    enabled: documentId !== '',
    staleTime: 1000 * 60 * 60 * 30, // 30 minutes
  })
}
